/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-10-25 10:01:49
 */
import { defineMessages } from 'react-intl';

const messageObject = {
  systemNotification: '系统维护通知',
  noticeContent: '通知内容',
  notificationCloseTime: '通知关闭时间',
  openNotification: '开启通知',
  notificationTip: '请填写通知内容,字数不超过100字,通知内容以单行显示',
  timePlaceholder: '选择时间不能早于系统时间',
  noticeNull: '未设置通知内容',
  maxLength: '输入内容不能不能超过100个字符',
  suposStatusTip: 'supOS运行中才能开启系统维护通知。',
  dateNull: '未设置通知关闭时间',
  dateError: '通知关闭时间早于当前时间',
  contentSpace: '通知内容不能全部为空格',
  edit: '修改',
  title: '通知设置',
  systemMaintenance: '系统维护',
  closeTip: '确定关闭系统维护通知？',
  gotIt: '知道了',
  statusTip: 'supOS非运行状态下不可用',
  endTime: '结束时间',
};

export default defineMessages(messageObject);
